module.exports = __webpack_public_path__ + "static/img/NSW-28.c223c7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-28.jpg
// module id = 96d6
// module chunks = 0